const Admin = () => import(/* webpackChunkName: "admin" */ '@/components/layouts/admin');
const UsersList = () =>
  import(/* webpackChunkName: "admin" */ '@/components/admin/users/users-list');
const NewUser = () => import(/* webpackChunkName: "admin" */ '@/components/admin/users/user-new');
const EditUser = () => import(/* webpackChunkName: "admin" */ '@/components/admin/users/user-edit');
const LicenceAreasList = () =>
  import(
    /* webpackChunkName: "admin" */ '@/components/admin/users/licence-areas/licence-areas-list'
  );
import { authorizeAdmin } from '@/router/auth';

const ADMIN_ROUTES = [
  {
    name: 'admin',
    path: '/admin',
    component: Admin,
    redirect: '/admin/users',
    beforeEnter: authorizeAdmin,
    children: [
      {
        path: 'users',
        alias: '',
        name: 'adminUsersList',
        component: UsersList
      },
      {
        path: 'users/new',
        name: 'adminNewUser',
        component: NewUser
      },
      {
        path: 'user/:userId/edit',
        name: 'adminEditUser',
        component: EditUser,
        props: true
      },
      {
        path: 'user/:userId/licence-areas',
        name: 'licenceAreasList',
        component: LicenceAreasList,
        props: true
      }
    ]
  }
];

export default ADMIN_ROUTES;
